export default function PrimePerksRules() {
  return (
    <div id="prime-perks-rules">
      <div className="fs-sm pt-5-5">
        <p className="label-2">Prime Perks Rules</p>
        <ul className="lh-lg">
          <li>
            Once a Prime Token is earned, it must be redeemed by January 31st of the following calendar year or it expires.
          </li>
          <li>
            Once redeemed, the guest retains the Prime Perk benefit for 12 months.
          </li>
          <li>
            Once redeemed, the first Perk is available immediately and is valid for 30 days. Each subsequent Perk will be available the first of the month, valid for that month only.
          </li>
          <li>
            Tokens may be saved to be combined with future Tokens for larger rewards.
          </li>
          <li>
            Once a Token is redeemed for a selected Perk, it cannot be changed or combined with future Perks.
          </li>
        </ul>
        <p>Certain restrictions apply. All Perks not available at all properties. See PLAYER SERVICES for full rules and regulations.</p>
      </div>
    </div>
  );
}
